(() => {
  const format = (value) => String(value).padStart(2, '0');

  document.querySelectorAll('[data-swa-deadline]').forEach((timer) => {
    const target = Date.parse(timer.dataset.swaDeadline || '');
    if (!Number.isFinite(target) || target <= Date.now()) {
      timer.hidden = true;
      return;
    }

    const update = () => {
      const remaining = target - Date.now();
      if (remaining <= 0) {
        timer.hidden = true;
        return false;
      }
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      timer.textContent = `${format(days)}:${format(hours)}:${format(minutes)}`;
      timer.hidden = false;
      return true;
    };

    if (update()) window.setInterval(update, 60000);
  });

  document.querySelectorAll('header-drawer > details').forEach((drawer) => {
    const trigger = drawer.querySelector(':scope > summary[aria-expanded]');
    if (!trigger) return;

    const syncExpandedState = () => {
      trigger.setAttribute('aria-expanded', drawer.open ? 'true' : 'false');
    };

    syncExpandedState();
    new MutationObserver(syncExpandedState).observe(drawer, {
      attributes: true,
      attributeFilter: ['open'],
    });
  });

  if (window.Shopify && window.Shopify.designMode) {
    const isUploadLiftEditorPlaceholder = (element) => {
      const text = element.textContent || '';
      return (
        text.includes('Upload field will appear here.') &&
        text.includes('Upload Field App Block')
      );
    };

    const hideUploadLiftEditorPlaceholder = () => {
      document.querySelectorAll('body *').forEach((element) => {
        if (!isUploadLiftEditorPlaceholder(element)) return;
        const childContainsFullPlaceholder = Array.from(element.children).some(
          isUploadLiftEditorPlaceholder
        );
        if (!childContainsFullPlaceholder) {
          element.hidden = true;
          element.style.setProperty('display', 'none', 'important');
        }
      });
    };

    let uploadLiftScanQueued = false;
    const queueUploadLiftScan = () => {
      if (uploadLiftScanQueued) return;
      uploadLiftScanQueued = true;
      window.requestAnimationFrame(() => {
        uploadLiftScanQueued = false;
        hideUploadLiftEditorPlaceholder();
      });
    };

    hideUploadLiftEditorPlaceholder();
    new MutationObserver(queueUploadLiftScan).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
